<template>
    <v-dialog
        v-model="isOpen"
        width="650"
        @click:outside="$emit('close')"
      >
        <v-card class="d-flex flex-column align-items-center p-2">
          <i class="mdi mdi-close close-icon" @click="$emit('close')"></i>
          <v-card-title class="pb-0">{{ animal.animal ? animal.animal.name : "" }}</v-card-title>
          <v-divider class="w-100"></v-divider>
          <v-card-text class="d-flex flex-column align-items-center">
            <the-table 
              :dataItems="[animal]"
              :headers="headersForTable"
            />
          </v-card-text>
          <v-card-actions>
            <v-btn class="error" @click="$emit('close')">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </template>
  
  <script>
  import TheTable from '../../layout/TheTable.vue'
  export default {
  components: { TheTable },
    name:"AlertTwoWeights",
    props:{
      isOpen:Boolean,
      animal:Object
    },
    data() {
      return {
        headersForTable:[
          {text:"Registro", value:"animal.register"},
          {text:"Bottom", value:"animal.code"},
          {text:"Data da Coleta", value:"date_classified"},
          {text:"Gord", value:"fat"},
          {text:"Prot", value:"protein"},
          {text:"Lact", value:"lactose"},
          {text:"CCS", value:"ccs"},
          {text:"Observação", value:"classified_comment"},
        ]
      }
    }
  }
  </script>
  
  <style scoped>
   .close-icon {
      right: 10px;
      top: 10px;
      position: absolute;
      font-size: 1.3rem;
      cursor: pointer;
    }
  </style>